import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translateSplit'
})
export class TranslateSplitPipe implements PipeTransform {

  transform(str: string, idLang: number): string {

    if (!str) return ''

    let parts = str.split('|')

    return parts[idLang] || parts[0]

  }

}
